import { useMapTooltipDisplayData } from "../useMapTooltipDisplayData"

// RoadBedLayerSegments
export default function RBLSContent() {
    const { displayData } = useMapTooltipDisplayData()
    const { RoadBedType } = displayData ?? {}

    return (
        <>
            <div className="tooltip-info-row">Тип дорожной одежды: {RoadBedType ?? 'Не известен'}</div>
        </>
    )
}
